import {useState} from 'react'
import FarmInspcectionForm from "./FarmInspcectionForm";
import FarmInspcectionList from "./FarmInspcectionList"

const ProFarmInspcection = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
     {fromIsShown ? (
        <FarmInspcectionForm addForm={setFromIsShown} update={upData} />
      ) : (
        <FarmInspcectionList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default ProFarmInspcection